/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
import AlertMessage from './Alert.js';
import { setBackgroundwithTheme, PreLoad } from './molstar_utils.js';
import { Loaders } from './Loaders.jsx';
import "molstar/build/viewer/molstar.css";
import { CleanMessages } from '../Utils.js';
import { updateIsActivated, updateIsDetected, updateIsLoaded, updateJobID } from './HookStateUpdate.jsx';

export function Controls(props) {
    sessionStorage.setItem('structures', JSON.stringify({}));
    document.addEventListener('toggletheme', function () {
        setBackgroundwithTheme(props.plugin);
    });
    
    if (props.job_id) {
        updateJobID(props.job_id);
        PreLoad(props.plugin, props.job_id );
        document.getElementById("analysis").scrollIntoView({behavior: "smooth"});
    } else {
      sessionStorage.setItem('structures', JSON.stringify({}));
      const volumediv = document.getElementById('volumediv');
      if (volumediv) {
        volumediv.classList.add('hidden');
      };
      props.plugin.clear()
      const hrefexport = document.getElementById('exporthref');
      if (hrefexport) {
        hrefexport.href = "#";
        if (!hrefexport.classList.contains('disabled')) {
          hrefexport.classList.add('disabled')
        };
      };
      updateIsDetected(false);
      updateIsActivated(false);
      updateIsLoaded(false);
      updateJobID('')
      CleanMessages()
    };


    return (
        <div id='controls' className="p-4 border-sky-950 border-2 bg-white dark:bg-stone-800 rounded-lg shadow-lg shadow-stone-800 dark:shadow-stone-400">
            
          <h3 className="text-md font-semibold whitespace-nowrap dark:text-gray-50">LOAD DATA </h3>
          <small className="text-gray-600 dark:text-gray-50">Select a method to see more options of how to load your data</small>
          <AlertMessage />
          <Loaders plugin={props.plugin} />
        </div>
        )
}
